export default function monroeReducer(state = [], action) {
  switch (action.type) {
    case "FETCH_MONROE":
      return [].concat.apply([], [...state, action.payload]);
    default:
      return state;
  }
}
